module.exports = __webpack_public_path__ + "img/mycrypto-copy-address.6041f899.png";